import { render } from "./noticia.vue?vue&type=template&id=1d76d66e&scoped=true"
import script from "./noticia.vue?vue&type=script&lang=js"
export * from "./noticia.vue?vue&type=script&lang=js"

import "./noticia.vue?vue&type=style&index=0&id=1d76d66e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d76d66e"]])

export default __exports__